let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dZiLY")).then(() => parcelRequire('iJQmu'));